import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppSettingsService } from '../config/app-settings.service';
import { AutomationLoginRequest, AutomationLoginResponse } from '../models/automation-auth.model';

@Injectable({ providedIn: 'root' })
export class AutomationAuthService {
  private readonly http = inject(HttpClient);
  private readonly appSettings = inject(AppSettingsService);


  /**
   * Calls backend API to get automation JWT token
   * @param request Automation login request with encrypted email
   * @returns Observable with token and expiry
   */
  authenticate(request: AutomationLoginRequest): Observable<AutomationLoginResponse> {
    const url = `${this.appSettings.baseApiUrl}/api/auth/automation/token`;
    return this.http.post<AutomationLoginResponse>(url, request);
  }
}
